<template>
  <div class="qr-conversion">
    <div class="qr-conversion__header">
      <h3 class="qr-conversion__title">Conversion Rates</h3>
      <p class="qr-conversion__subtitle">Stage performance at a glance</p>
    </div>

    <div class="qr-conversion__chart">
      <ja-apex-chart
        type="radialBar"
        :height="280"
        :options="chartOptions"
        :series="series"
      />
      <div class="qr-conversion__center">
        <span class="qr-conversion__center-value">{{ overallValue }}%</span>
        <span class="qr-conversion__center-label">Overall</span>
      </div>
    </div>

    <div class="qr-conversion__legend">
      <div
        v-for="rate in rates"
        :key="rate.label"
        class="qr-conversion__legend-item"
      >
        <span
          class="qr-conversion__dot"
          :style="{ background: rate.color }"
        />
        <span class="qr-conversion__legend-label">{{ rate.label }}</span>
        <span class="qr-conversion__legend-value">{{ rate.value }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
import JaApexChart from "@/views/taxipoint/journey-analytics/components/JaApexChart.vue";

export default {
  name: "QrConversionRates",
  components: { JaApexChart },
  props: {
    rates: { type: Array, required: true },
    overallValue: { type: [Number, String], default: 0 },
  },
  computed: {
    series() {
      return this.rates.map((r) => r.value);
    },
    chartOptions() {
      return {
        chart: {
          type: "radialBar",
          sparkline: { enabled: false },
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
            },
            track: {
              background: "#f3f2f7",
              strokeWidth: "100%",
            },
            dataLabels: {
              name: { show: false },
              value: { show: false },
            },
          },
        },
        colors: this.rates.map((r) => r.color),
        labels: this.rates.map((r) => r.label),
        legend: { show: false },
        stroke: { lineCap: "round" },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.qr-conversion {
  background: #fff;
  border-radius: 18px;
  padding: 1.5rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  &__header {
    margin-bottom: 0.5rem;
  }

  &__title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d2d2d;
    margin: 0 0 0.35rem;
  }

  &__subtitle {
    font-size: 0.8125rem;
    color: #a8a8b3;
    margin: 0;
  }

  &__chart {
    position: relative;
  }

  &__center {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: none;
  }

  &__center-value {
    display: block;
    font-size: 1.75rem;
    font-weight: 700;
    color: #2d2d2d;
    line-height: 1.2;
  }

  &__center-label {
    display: block;
    font-size: 0.8rem;
    color: #a8a8b3;
  }

  &__legend {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: -0.5rem;
  }

  &__legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__legend-label {
    color: #6e6b7b;
    flex: 1;
  }

  &__legend-value {
    font-weight: 600;
    color: #2d2d2d;
  }
}
</style>
